import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import AgencyFeeFactory from "../../Entity/Factories/AgencyFeeFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { AgencyFeeInterface } from "../../Entity/Entities/AgencyFee/AgencyFeeInterface";
import Translator from "../../Translation/Translator";

export default function* agencyFeeEnd(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_AGENCY_FEE_UPDATE_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_AGENCY_FEE_END_REQUEST
    });

    const res = yield call(Http.patch, `agency-fees/${action.payload?.id}/end`, action.payload);

    const agencyFee: AgencyFeeInterface = AgencyFeeFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_AGENCY_FEE_UPDATE_SUCCESS,
      payload: {
        agencyFee: agencyFee
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-agency-fee-updated-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, agencyFee);
    }

  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_AGENCY_FEE_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchAgencyFeeEnd() {
  yield takeEvery(Constants.GLOBAL_AGENCY_FEE_END_START, agencyFeeEnd);
}
